import { Card, CardContent, CardHeader } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";

export const ServicesSkeleton = () => {
  const isMobile = typeof window !== 'undefined' && window.innerWidth < 768;
  const skeletonCount = isMobile ? 3 : 5;

  return (
    <div className="columns-1 md:columns-2 gap-8 space-y-8">
      {Array.from({ length: skeletonCount }).map((_, index) => (
        <div key={index} className="break-inside-avoid mb-8">
          <Card>
            <CardHeader className="bg-bbz-beige/30">
              <Skeleton className="h-7 w-3/4 mb-2" />
              <Skeleton className="h-4 w-full" />
            </CardHeader>
            <CardContent className="p-6 space-y-4">
              {[1, 2, 3].map((serviceIndex) => (
                <div key={serviceIndex} className="border-b border-bbz-green/10 pb-4 last:border-0">
                  <div className="flex justify-between items-start mb-2">
                    <div className="flex-1">
                      <Skeleton className="h-5 w-2/3 mb-2" />
                      <Skeleton className="h-3 w-1/4" />
                    </div>
                    <Skeleton className="h-5 w-16" />
                  </div>
                  <Skeleton className="h-4 w-full mt-2" />
                  <Skeleton className="h-4 w-4/5 mt-1" />
                </div>
              ))}
            </CardContent>
          </Card>
        </div>
      ))}
    </div>
  );
};
